<template>
    <div>
        <section class="main-slider">
            <div class="page-header-bg" style="background-image: url(static/picture/banner/B4.jpg);">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                        <!-- 新闻资讯 -->
                        {{ $t('header.mb_news') }}
                    </h1>
                    <h3>
                        <!-- 以客户的成功定义成功，赋能企业管理，来自企业的信赖 -->
                        {{ $t('news.news_banner_subtitle') }}
                    </h3>
                </div>
                <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'mb_home' }">
                             <!-- 首页 -->
                             {{ $t('header.home') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>
                             <!-- 新闻资讯 -->
                             {{ $t('header.mb_news') }}
                        </el-breadcrumb-item>
                  
                    </el-breadcrumb>
                </div>
            </div>
        </section>
        <!-- 内容 -->
        <section class="blog-details">
            <div class="container">
                <div class="row">
                    <div class="comment-one"> 
                        <div class="comment-one__single" v-for="(item, index) in list" :key="index" @click="handleDetail(item)">
                            <div class="comment-one__image" v-if="item.imgUrl">
                                <img :src="item.imgUrl" alt="">
                            </div>
                            <div class="comment-one__content" :class=" item.imgUrl ? 'comment-one__content_w': ''">
                                <h3 class="news_content_title news_content_text">
                                     <!-- {{ item.title }} -->
                                    {{ $t(`news.${item.i18n_title}`) }}
                                </h3>
                                <!-- <p class="news_content_text news_content_margin">{{ item.centent }}</p> -->
                                <div class="news_content_margin news_content_time">{{ item.time }}</div>
                                <!-- <a class="thm-btn news_content_margin"><span style="margin-right: 10px;">查看详情</span> <i class="fa fa-caret-right" aria-hidden="true"></i></a> -->
                            </div>
                        </div>
                    </div>
                    <!-- 分页 -->
                    <div class="col-lg-12">
                                <div  class="blog-pagination justify-content-center">
                                <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="queryParam.pageNum"
                                  
                                    :page-size="queryParam.pageSize"
                                    :total="total"
                                >
                                </el-pagination>
                            </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'mbNews',
     mixins: [MixinsList],
    data () {
        return {
            list: [],
            newsIndex: 0,
            queryParam: {
                pageNum: 1,
                pageSize: 10,
                type: "",
            },
            total: 0
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () {
     
    },
    methods: {
        handleSizeChange(i, j) {
            Object.assign(this.queryParam, { pageSize: i })
            this.getList()
        },
        handleCurrentChange(i, j) {
            Object.assign(this.queryParam, { pageNum: i })
            this.getList()

            $("html, body").animate({
                scrollTop: $('html').offset().top
                },
            );
        },
        // 获取内容
        async getList() {
            // const { result } = res
            // var arr = JSON.parse(JSON.stringify(result.records))  // 设备信息
            // if( this.queryParam.type ) {
            //     arr = arr.filter(item => item.type == this.queryParam.type);
            // }
            // this.total = arr.length
            // var p = (this.queryParam.pageNum-1)*this.queryParam.pageSize
            // this.list = arr.splice(p,this.queryParam.pageSize)

            try {
                  let result = {}
            if( this.data && Object.keys(this.data).length > 0) {
                 result = this.data
            } else {
                result = await loadData('newsData', this.lang)
                this.data = result
            }
            var arr = JSON.parse(JSON.stringify(result.records))  // 设备信息
            if( this.queryParam.type ) {
                arr = arr.filter(item => item.type == this.queryParam.type);
            }
            this.total = arr.length
            var p = (this.queryParam.pageNum-1)*this.queryParam.pageSize
            this.list = arr.splice(p,this.queryParam.pageSize)
            } catch (error) {
                console.log(error)
            }
        },
        // 详情
        handleDetail(item) {
            if(item.id) {
                this.$router.push({
                path: "mbNewsDetail",
                query: {
                    id: item.id,
                }
            });
            }
            
          
        }
    }
}
</script>
<style scoped>
.page-header-bg {
    background-color: transparent; 
}

.page-header__inner h1 {
    text-align: center;
    font-size: var(--font-size-20) !important;
    text-justify: distribute-all-lines;  /*兼容ie*/
}
.page-header__inner h3 {
    font-size: 16px;
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
}

.main-slider .container {
    padding-top: 120px;
    padding-bottom: 120px;
}
.blog-details {
    padding: 60px 0 60px;
}
.blog-pagination {
    margin-top: 30px;
}
.el_breadcrumb {
    color: var(--notech-primary) !important;
}
/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    color: var(--notech-white);
    font-size: 16px;
    font-weight: 700;
    transition: all 500ms ease;
}
.comment-one__image {
    width: 30%;
    text-align: center;
}
.comment-one__image img {
    border-radius: 0;
    text-align: center;
    max-width: 100%;
    max-height: 100%;
}
.comment-one__single {
    cursor: pointer;
    width: 100%;
    flex-direction: row;
    padding: 30px 0;
    margin-bottom: 0;
    
}
.comment-one__content_w{
    margin-left: 0;
}

.comment-one__content {
    width: 70%;
    margin-top: 0;
    padding-left: 10px;
}

.thm-btn{
    padding: 4px 30px;
 }
 .news_content_margin{
    margin-top: 17px;
 }

 .news_content_text {
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
}
 .news_content_time {
    color: var(--notech-base);
  }
</style> 
